module.exports = __webpack_public_path__ + "img/bg_1.dcb7a2cf.png";